export default __webpack_public_path__ + "static/osiedle-kwiat-logo-79fb11bbcb40c3e478c8e9465d2fc69f.png";